/*
 * @Author: Girish Akhare
 * @Date: 2021-02-04 12:28:18
 * @Last Modified by: Girish Akhare
 * @Last Modified time: 2021-02-04 12:29:52
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomCardComponent } from './simple-card/simple-card.component';

@NgModule({
  imports: [CommonModule, NgSelectModule],
  exports: [CustomCardComponent],
  declarations: [CustomCardComponent],
  providers: []
})
export class CustomCardModule {}
